export const uploadFile = async (
  file?: { blob?: Blob; name: string },
  uploadRequest?: any,
  fetch?: any
) => {
  if (!fetch || !uploadRequest || !file?.blob?.size) {
    return null;
  }

  try {
    const { data } = await uploadRequest({
      variables: {
        application: 'ENTITY_PAGES',
        fileSize: file.blob.size,
        fileName: file.name || 'image',
        type: file.blob.type || 'image/jpeg',
      },
    });

    if (!data?.uploadRequest?.success) {
      return {
        error: 'UPLOAD_SERVICE_REQUEST_ERROR',
      };
    }

    const { id, url, authToken } = data?.uploadRequest?.success;

    if (!url && !authToken) {
      return {
        error: 'UPLOAD_SERVICE_REQUEST_ERROR',
      };
    }

    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Upload-Offset': '0',
        'Tus-Resumable': '1.0.0',
        'Content-Type': 'application/offset+octet-stream',
      },
      body: file.blob,
    });

    if (!response.ok) {
      return {
        error: 'UPLOAD_FAILED',
      };
    }

    return {
      id,
    };
  } catch (e) {
    return {
      error: 'UPLOAD_FAILED',
    };
  }
};
